import classNames from 'classnames';
import {LucideIcon} from 'lucide-react';
import * as React from 'react';

export type IconChipTone = 'brand' | 'accent' | 'danger' | 'success' | 'meaning' | 'listening' | 'speaking' | 'writing';
export type IconChipSize = 'sm' | 'md' | 'lg';
export type IconChipShape = 'square' | 'circle';

export interface IconChipProps extends React.HTMLAttributes<HTMLSpanElement> {
    icon: LucideIcon;
    tone?: IconChipTone;
    size?: IconChipSize;
    shape?: IconChipShape;
    iconSize?: number;
}

const toneClasses: Record<IconChipTone, string> = {
    brand: 'mp-icon-chip--brand',
    accent: 'mp-icon-chip--accent',
    danger: 'mp-icon-chip--danger',
    success: 'mp-icon-chip--success',
    meaning: 'mp-icon-chip--meaning',
    listening: 'mp-icon-chip--listening',
    speaking: 'mp-icon-chip--speaking',
    writing: 'mp-icon-chip--writing',
};

const sizeClasses: Record<IconChipSize, string> = {
    sm: 'mp-icon-chip--sm',
    md: 'mp-icon-chip--md',
    lg: 'mp-icon-chip--lg',
};

const defaultIconSizes: Record<IconChipSize, number> = {
    sm: 16,
    md: 20,
    lg: 22,
};

export const IconChip: React.FunctionComponent<IconChipProps> = ({icon: Icon, tone = 'brand', size = 'md', shape = 'square', iconSize, className, ...rest}: IconChipProps) => (
    <span className={classNames('mp-icon-chip', sizeClasses[size], toneClasses[tone], {'mp-icon-chip--circle': shape === 'circle'}, className)} {...rest}>
        <Icon size={iconSize ?? defaultIconSizes[size]}/>
    </span>
);
